module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isResendModalShown) ? _c('div', [(_vm.isLoading) ? _c('loading-component') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "margin-top": "150px"
    }
  }, [(_vm.ResetStatus) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _vm._v(" "), _vm._m(0)]) : _vm._e()])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "passwordReset-header"
  }, [_c('p', {
    staticClass: "modal-title"
  }, [_vm._v("Success!")]), _vm._v(" "), _c('p', {
    staticClass: "modal-description"
  }, [_vm._v("A new activation email has been sent to you. Please check your inbox.")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "passwordReset-header"
  })])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4488876c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4488876c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/listData/ResendActivation.vue
// module id = 513
// module chunks = 4